import axios from 'axios';
import { isObject, isSafeInteger } from 'lodash';

import config from 'commons-general/config/index.js';
import { HTTPService } from '@sm360/widget-commons-core-services';

import CookieService from 'commons-general/services/CookieService/CookieService.js';

/**
 * Services to interact with leads
 */
class LeadService {
    constructor() {
        this.basePath = `${config.endpoint.widget}/widgets`;
        this.leadBasePath = `${this.basePath}/leads`;
    }

    createLead(lead) {
        if (!isObject(lead)) {
            return Promise.reject(
                HTTPService.formatRejectResponse('invalidParams', {
                    status: 400,
                })
            );
        }

        const trackedPageCookie = CookieService.getToken('primary-tracked-page');
        const adgearUidCookie = CookieService.getToken('aguid');

        const trackedLeadCreation = {
            leadCreation: lead,
            primaryTrackedPage: null,
            adgearUid: null,
        };

        if (trackedPageCookie) {
            try {
                trackedLeadCreation.primaryTrackedPage = JSON.parse(trackedPageCookie.replace(/\\/g, ''));
            } catch (e) {
                throw e;
            }
        }

        if (adgearUidCookie) {
            trackedLeadCreation.adgearUid = adgearUidCookie;
        }

        return axios.post(this.leadBasePath, trackedLeadCreation);
    }

    /**
     * Will update a given lead with the given financing informations
     * @param {Object} financing The financing object added to the lead
     * @param {number} leadId The id of the lead to update. Must be an integer
     */
    addLeadFinancing(financing, leadId) {
        if (!isObject(financing) || !isSafeInteger(leadId)) {
            return Promise.reject(
                HTTPService.formatRejectResponse('invalidParams', {
                    status: 400,
                })
            );
        }

        return axios.post(`${this.basePath}/financing`, { ...financing, leadId });
    }

    /**
     * Update the given lead with the given TradeIn information
     * @param {number} leadId is the id of the lead to update
     * @param {Object} tradeIn Represent a TradeInVehicle from the Showroom360 lib
     */
    addTradeInInformation(leadId, tradeIn) {
        if (!isObject(tradeIn) || !isSafeInteger(leadId)) {
            return Promise.reject(
                HTTPService.formatRejectResponse('invalidParams', {
                    status: 400,
                })
            );
        }

        return axios.post(`${this.leadBasePath}/${leadId}/tradein`, tradeIn);
    }
}

export default new LeadService();
